import { ScrollTriggerProvider } from '@examdojo/chat';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ImageChatScrollProvider extends ScrollTriggerProvider {
  private readonly scrollTrigger$$ = new Subject<void>();

  scrollTrigger$ = this.scrollTrigger$$.asObservable();

  scrollChat() {
    this.scrollTrigger$$.next();
  }
}
